import { lazy } from 'react'
export default lazy(() => import(/* webpackChunkName: "gameCreation" */'./SelectStakeContainer'))
try {
    // @ts-ignore
    SelectStake.displayName = "SelectStake";
    // @ts-ignore
    SelectStake.__docgenInfo = { "description": "", "displayName": "SelectStake", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/routes/SelectStake/index.ts#SelectStake"] = { docgenInfo: SelectStake.__docgenInfo, name: "SelectStake", path: "src/routes/SelectStake/index.ts#SelectStake" };
}
catch (__react_docgen_typescript_loader_error) { }